package com.example.event_management_system.data.models

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

object LongAsDoubleSerializer : KSerializer<Long> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("LongAsDouble", PrimitiveKind.DOUBLE)

    override fun serialize(encoder: Encoder, value: Long) =
        encoder.encodeDouble(value.toDouble())

    override fun deserialize(decoder: Decoder): Long =
        decoder.decodeDouble().toLong()
}
